import {Validator} from '@/type/validation/result';
import {半角カナ禁止, 必須入力} from '@/type/validation/validator';

export interface 入庫作成依頼型 {
    入庫登録商品選択一覧: 入庫候補商品型[];
}

export enum 入庫マスタ選択区分型 {
    医薬品 = '医薬品',
    その他品 = 'その他品',
    採用品 = '採用品',
}

export interface 商品ソート区分型 {
    値: string;
    ラベル: string;
}

export const 商品ソート区分一覧: 商品ソート区分型[] = [
    {値: '商品名', ラベル: '商品名'},
    {値: '規格容量', ラベル: '規格・容量'},
    {値: 'メーカー名', ラベル: 'メーカー名'},
    {値: '卸', ラベル: '卸'},
];

export const 仕入先を抜いた商品ソート区分一覧: 商品ソート区分型[] = [
    {値: '商品名', ラベル: '商品名'},
    {値: '規格容量', ラベル: '規格・容量'},
    {値: 'メーカー名', ラベル: 'メーカー名'},
];
export interface 入庫候補商品型 {
    選択: boolean;
    商品コード: string;
    JANコード: string;
    採用区分: string;
    商品区分: string;
    メーカー名: string;
    商品名: string;
    規格容量: string;
    入庫数: number;
    卸コード: string;
}

export interface 入庫候補検索結果型 {
    入庫商品一覧: 入庫候補商品型[];
    アラートメッセージ: string;
}

export interface 入庫候補検索条件型 {
    マスタ検索区分: 入庫マスタ選択区分型;
    卸コード: string;
    商品ソート区分: string;
    メーカー名: string;
    商品名カナ: string;
    取得件数: number;
    取得開始位置: number;
}

export interface コード入力入庫候補商品型 {
    選択: boolean;
    商品コード: string;
    JANコード: string;
    採用区分: string;
    商品区分: string;
    メーカー名: string;
    商品名: string;
    規格容量: string;
    入庫数: number;
    卸コード: string;
}

export interface コード入力入庫候補検索結果型 {
    入庫商品一覧: 入庫候補商品型[];
    アラートメッセージ: string;
}

export interface コード入力入庫候補検索条件型 {
    JANコードまたは販売GTINコード: string;
}

function 三文字以上の入力が必要(value: string) {
    if (!value) {
        return false;
    }
    return (value.length >= 3);
}

export function 確定対象である(入庫候補商品: 入庫候補商品型) {
    return 入庫候補商品.選択;
}

export const 入庫候補検索条件バリデータ一覧: Validator[] = [
    {
        name: '商品名カナ',
        constraints: [
            {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
            {method: 三文字以上の入力が必要, message: '商品名カナは３文字以上の入力が必要です'},
        ],
    },
];

export const コード入力検索条件バリデータ一覧: Validator[] = [
    {
      name: 'JANコードまたは販売GTINコード',
      constraints: [
        {method: 必須入力, message: 'JAN/GTINコードは入力が必須です'},
      ],
    },
];

function マイナス不可(value: number): boolean {
    return value > -1;
}

function 入庫数は5桁以内(value: number): boolean {
    return value <= 99999;
}

export const 入庫候補商品バリデータ一覧: Validator[] = [
    {
        name: '入庫数',
        constraints: [
            {method: 必須入力, message: '入庫数は入力が必要です'},
            {method: マイナス不可, message: '入庫数にマイナスの値は入力できません'},
            {method: 入庫数は5桁以内, message: '入庫数は整数部5桁以内で入力してください'},
        ],
    },
    {
        name: '卸コード',
        constraints: [
            {method: 必須入力, message: '卸は選択が必要です'},
        ],
    },
];
